module.exports = __webpack_public_path__ + "static/media/19.ce2e9378.jpg";